
<div>
  <div class="d-flex flex-col pricing-container justify-center" style="padding: 24px 12px 24px 12px;
    gap: 32px;">
    <div class="d-flex flex-col align-items-center">
        <div class="heading main-heading">Choose your right plan</div>
        <div class="content">Select from best plans, ensuring a perfect match. Need more or less?
    Customise your subscription for a seamless fit.</div>
    </div>
    <div class="d-flex flex-row justify-center group-btn" *ngIf="cycles?.length > 0">
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="d-flex flex-wrap justify-center pricing-toggle-group">
        <mat-button-toggle *ngFor="let billingCycle of cycles" [appearance]="'standard'" [value]="billingCycle.billingDays" 
            [checked]="selectedBillingCycle?.billingDays == billingCycle.billingDays" [ngClass]="{'selected-mat-btn-toggle': selectedBillingCycle?.billingDays == billingCycle.billingDays}"
             (change)="onBillingCycleChange(billingCycle.billingDays)" class="btn-toggle-group">
             <div class="billing-container-block">
                <div [ngClass]="{
                    'selected-billing-text-color': subscriptionBusinessService?.currentlyActiveCompanySubscription?.subscriptionPlan?.billingDays == billingCycle.billingDays && selectedBillingCycle?.billingDays == billingCycle.billingDays , 
                    'normal-billing-text-color': subscriptionBusinessService?.currentlyActiveCompanySubscription?.subscriptionPlan?.billingDays != billingCycle.billingDays && selectedBillingCycle?.billingDays != billingCycle.billingDays  
                }" class="billed-price billing-text">{{capitalize(billingCycle.displayValue)}}</div>
             </div>
        </mat-button-toggle>
      </mat-button-toggle-group>
      <!-- add -->
      <!-- <mat-button-toggle-group class="group-toggle" name="fontStyle" aria-label="Font Style"
      *ngIf="data.heading === 'Connected Sources'" [value]="defaultConnectedSourcesFilterButton">
      <mat-button-toggle class="group-btn" *ngFor="let item of connectedSourcesFilterButtons"
          [value]="item.value">{{item.displayName}}</mat-button-toggle>
  </mat-button-toggle-group> -->
      <!-- add -->
    </div>
  </div>
  <div class="d-flex pricing-container justify-center" *ngIf="pricingData?.length > 0">
    <ng-container *ngFor="let item of pricingData; let index = index;">

      <!-- OTHER PLAN CARD STARTS HERE -->
      <ng-container *ngIf="otherCardPlans[(item?.plan)?.toUpperCase()]?.[selectedBillingCycle?.billingDays] as planDetail; else growthPlanCard">
        <mat-card class="p-0 other-plans-card">
          <div class="pricing-left-card">
            <mat-card-content>
              <div class="d-flex flex-col plan-details-container">
                <div class="d-flex items-center flex-col plan-heading-container">
                  <div class="heading free-heading text-center" [ngClass]="item.headingClass">
                    {{planDetail?.[0]?.description | jsonParse:'planName' || item.heading}}
                  </div>
                  <div class="w-100 d-flex justify-center">
                    <div class="text text-center">{{planDetail?.[0]?.description | jsonParse:'planDescription' || item.text}}</div>
                  </div>
                </div>
                <ng-container *ngTemplateOutlet="content; context : {'item': item, 'planDetail': planDetail}  "></ng-container>
              </div>
              <div class="horizontal-line"></div>
              <div class="d-flex flex-col pricing-features-container">
                <div class="pricing-features-heading">{{item.innerHeading}}</div>
                <div class="d-flex flex-col flex-gap-4 pricing-feature">
                  <div *ngFor="let key of castArray(planDetail?.[0].description | jsonParse: 'bulletPoints'); trackBy:trackByBulletPoint"  class="d-flex items-center">
                      <img src="assets/images/subscription/span.oval.svg">
                      <span class="description">{{key | getObjectKeyOrString: 'key'}}</span>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </div>
        </mat-card>
      </ng-container>
      <!-- OTHER PLAN CARD ENDS HERE -->


      <!-- GROWTH PLAN CARD STARTS HERE-->
      <ng-template #growthPlanCard let-variable="item">
        <mat-card *ngIf="growthPlanNames?.includes(item?.plan?.toUpperCase())" class="p-0 growth-plans-card">
          <div class="pricing-left-card">
            <mat-card-content>
              <div class="d-flex flex-col plan-details-container">
                <div class="d-flex items-center flex-col plan-heading-container">
                  <div class="heading free-heading text-center" [ngClass]="item.headingClass">
                    {{selectedSubscriptionPlan?.description  | jsonParse:'planName' || item.heading}}
                  </div>
                  <div class="w-100 d-flex justify-center">
                    <div class="text text-center">{{selectedSubscriptionPlan?.description  | jsonParse:'planDescription' || item.heading || item.text}}</div>
                  </div>
                </div>
                <ng-container *ngTemplateOutlet="content; context : {'item': item}  "></ng-container>
              </div>
              <div class="horizontal-line"></div>
              <div class="d-flex flex-col pricing-features-container">
                <div class="pricing-features-heading">{{selectedSubscriptionPlan?.description  | jsonParse:'planHeading'}}</div>
                <div class="d-flex flex-col flex-gap-4 pricing-feature">
                  <div *ngFor="let key of selectedSubscriptionPlan?.description  | jsonParse:'bulletPoints'; trackBy:trackByBulletPoint"  class="d-flex items-center">
                      <img src="assets/images/subscription/span.oval.svg">
                      <span class="description">{{key | getObjectKeyOrString: 'key'}}</span>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </div>
        </mat-card>
      </ng-template>
      <!-- GROWTH PLAN CARD ENDS HERE-->


       <!-- SWITCH CASE TO DETERMINE WHICH CONTENT TO LOAD FOR PLAN STARTS HERE -->
       <ng-template #content let-variable="item" let-planDetail="planDetail">
        <ng-container [ngSwitch]="item.plan">
          <ng-container *ngSwitchCase="'lite'" >
            <ng-container *ngTemplateOutlet="otherPlanContent; context : {'item': item, 'planDetail': planDetail}  "></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'growth'">
            <ng-container *ngTemplateOutlet="growthPlanContent; context : {'item': item}  "></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'enterprise'">
            <ng-container *ngTemplateOutlet="enterprisePlanContent; context : {'item': item, 'planDetail': planDetail}  "></ng-container>
          </ng-container>
        </ng-container>
      </ng-template>
      <!-- SWITCH CASE TO DETERMINE WHICH CONTENT TO LOAD FOR PLAN ENDS HERE -->
      


      <!-- OTHER PLAN CARD CONTENT STARTS HERE -->
      <ng-template #otherPlanContent let-variable="item" let-planDetail="planDetail">
        <div class="price-wrapper d-flex flex-col">
          <div class="price-container d-flex flex-col">
            <div class="money text-center d-flex align-items-center justify-center">
              <span class="dollar-font">$</span><span class="money-0">{{planDetail?.[0]?.basePrice}}</span><span class="month">/{{planDetail?.[0]?.billingDays | callbackPipe:callbackNameEnum.getBillingCycle : { passTrueForDayFalseForDaily: true } }}</span>
            </div>
            <div class="events-text text-center">{{planDetail?.[0]?.description | jsonParse:'highlightedFeature' || 'Includes 1 million free events'}}</div>
            <div class="connector text-center" >{{planDetail?.[0]?.description | jsonParse:'featureSpotlight' || '50 selected connectors'}}</div>
          </div>
        </div>
        <!-- TODO check if trial plan is expired and disable select plan option -->
        <!-- <div class="button-block current-plan">
          <button mat-flat-button class="w-100" [disabled]="subscriptionBusinessService?.companySubscriptions.length > 0 ">{{'Trial Monthly' == subscriptionBusinessService?.currentlyActiveCompanySubscription?.subscriptionPlan?.name ? 'Current Plan': 'Select Plan'}}</button>
        </div> -->
        <div class="button-block {{item.plan}}">
          <ng-container *ngTemplateOutlet="actionButtons; context: {otherPlanCard: planDetail}"></ng-container>
        </div>
      </ng-template>
      <!-- LITE PLAN CARD CONTENT ENDS HERE -->


      <!-- ENTERPRISE PLAN CARD CONTENT STARTS HERE -->
      <ng-template #enterprisePlanContent let-tem="item">
        <div class="quote-block d-flex flex-col">
          <span>Get a custom quote</span>
          <span>tailored to your</span>
          <span>requirements</span>
        </div>
        <div class="button-block {{item.plan}}">
          <ng-container *ngTemplateOutlet="talkToSalesButton;"></ng-container>
        </div>
      </ng-template>
      <!-- ENTERPRISE PLAN CARD CONTENT ENDS HERE -->

      <!-- GROWTH PLAN or SLIDER PLAN CARD CONTENT STARTS HERE -->
      <ng-template #growthPlanContent let-tem="item">
        <ng-container *ngIf="selectedSubscriptionPlan != undefined; else loadingBlock">
          <div class="price-wrapper d-flex flex-col">
            <div class="price-container d-flex flex-col">
              <div class="money d-flex justify-center items-center flex-gap-half">
                <div class="strike-block" *ngIf="selectedSubscriptionPlan?.strikeOutPrice">
                  <del>
                    <div class="d-flex items-center">
                      <span class="dollar-strike-text">$</span><span class="strike-text">{{selectedSubscriptionPlan?.strikeOutPrice}} </span>
                    </div>
                  </del>
                </div>
                <div class="d-flex items-center">
                  <span class="dollar-font">$</span>
                  <span class="font-239">
                    {{selectedSubscriptionPlan?.strikeOutPrice ? selectedSubscriptionPlan?.displayPrice : selectedSubscriptionPlan?.basePrice}}
                  </span>
                  <span class="month">/{{selectedSubscriptionPlan?.billingDays | callbackPipe:callbackNameEnum.getBillingCycle : {passTrueForDayFalseForDaily: true, strikeOutPrice: selectedSubscriptionPlan?.strikeOutPrice} }}</span>
                </div>
              </div>
              <div class="pricing-slider-container" *ngIf="options != undefined" >
                <ng-container *ngIf="showSlider">
                  <ngx-slider [(value)]="selectedPlanIndexGroupedByBillingCycle" [options]="options" (userChange)="onSliderPositionChange($event)" ></ngx-slider>
                </ng-container>
              </div>
            </div>
            <div class="d-flex justify-center">
              <span>{{selectedSubscriptionPlan?.description  | jsonParse:'sliderTitle'}}</span>
            </div>
          </div>
          <div class="button-block {{item.plan}}">
            <ng-container *ngTemplateOutlet="actionButtons;"></ng-container>
          </div>
        </ng-container>
        <ng-template #loadingBlock>
          <div class="d-flex justify-center align-items-center mt-4">
            Loading plans...<mat-spinner diameter="30"></mat-spinner>
          </div>
        </ng-template>
      </ng-template>
      <!-- GROWTH PLAN or SLIDER PLAN CARD CONTENT ENDS HERE -->

      <!-- ACTION BUTTON TEMPLATE STARTS HERE -->


      <ng-template #actionButtons let-otherPlanCard="otherPlanCard">
        
        <ng-container *ngIf="subscriptionBusinessService?.showMigrationFlowInPricingPage ; else nonMigrationFlow">
          <ng-container *ngIf="otherPlanCard !== undefined;">
            <ng-container *ngIf="subscriptionBusinessService?.currentlyActiveCompanySubscription?.subscriptionPlan?.id != otherPlanCard?.[0].id; else currentPlanButton">
              <ng-container *ngIf="subscriptionBusinessService?.currentlyActiveCompanySubscription?.status !== SUSPENDED; else talkToCustomerSupportButton ">
                <ng-container *ngTemplateOutlet="selectButton; context: { 'otherPlanCard': otherPlanCard }"></ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="otherPlanCard === undefined;">
            <ng-container *ngIf="selectedSubscriptionPlan?.billingDays === subscriptionBusinessService?.newSubscriptionPlanMatchingOldSubscription?.billingDays && 
            subscriptionBusinessService?.isMigrationAnomaly === false && 
            subscriptionBusinessService?.isOldSubscriptionPlanEnterprise === false; 
            else talkToCustomerSupportButton">
              <ng-container *ngTemplateOutlet="selectButton;"></ng-container>
            </ng-container>
          </ng-container>
        </ng-container>


        <ng-template #nonMigrationFlow>
          <ng-container *ngIf="otherPlanCard !== undefined;">
            <ng-container *ngIf="haveModifyPermissions ; else contactAdmin">
              <ng-container *ngIf="subscriptionBusinessService.isCurrentlyActiveCompanySubscriptionNameTrial || (subscriptionBusinessService?.currentlyActiveCompanySubscription?.subscriptionPlan?.managedBySarasOnly != true && subscriptionBusinessService?.currentlyActiveCompanySubscription?.status != UPGRADED )  ; else talkToSalesButton">
                <ng-container *ngIf="subscriptionBusinessService?.currentlyActiveCompanySubscription?.subscriptionPlan?.id != otherPlanCard?.[0]?.id; else currentPlanButton">
                  <ng-container *ngIf="subscriptionBusinessService?.currentlyActiveCompanySubscription?.status !== SUSPENDED; else talkToCustomerSupportButton ">
                    <ng-container *ngTemplateOutlet="selectButton; context: { 'otherPlanCard': otherPlanCard }"></ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="otherPlanCard === undefined;">
            <ng-container *ngIf="haveModifyPermissions ; else contactAdmin">
              <ng-container *ngIf="subscriptionBusinessService.isCurrentlyActiveCompanySubscriptionNameTrial || (subscriptionBusinessService?.currentlyActiveCompanySubscription?.subscriptionPlan?.managedBySarasOnly != true && subscriptionBusinessService?.currentlyActiveCompanySubscription?.status != UPGRADED )  ; else talkToSalesButton">
                <ng-container *ngIf="subscriptionBusinessService?.currentlyActiveCompanySubscription?.subscriptionPlan?.id != selectedSubscriptionPlan?.id; else currentPlanButton">
                  <ng-container *ngIf="subscriptionBusinessService?.currentlyActiveCompanySubscription?.status !== SUSPENDED; else talkToCustomerSupportButton ">
                    <ng-container *ngTemplateOutlet="selectButton; context: { 'otherPlanCard': otherPlanCard }"></ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-template>
        
      </ng-template>
      <!-- ACTION BUTTON TEMPLATE ENDS HERE -->


      <!-- DIFFERENT KINDS OF ACTION BUTTON TEMPLATES STARTS HERE -->
      <ng-template #talkToSalesButton>
        <button mat-flat-button color="primary" class="w-100" (click)="subscriptionBusinessService.goToContactUs()">Talk to Sales</button>
      </ng-template>
      <ng-template #talkToCustomerSupportButton>
        <button mat-flat-button color="primary" class="w-100" (click)="subscriptionBusinessService.talkToCustomerSupport()">Talk to customer support</button>
      </ng-template>
      <ng-template #selectButton let-otherPlanCard="otherPlanCard">
        <button mat-flat-button color="primary" class="w-100" (click)="onSelectPlanClick(otherPlanCard?.[0] || selectedSubscriptionPlan)">Select Plan</button>
      </ng-template>
      <ng-template #currentPlanButton>
        <button mat-flat-button color="primary" class="w-100" disabled >Current Plan</button>
      </ng-template>
      <ng-template #contactAdmin>
        <button mat-flat-button color="primary" class="w-100" (click)="subscriptionBusinessService.onContactAdminForPlanChange()">Contact Admin</button>
      </ng-template>
      <!-- DIFFERENT KINDS OF ACTION BUTTON TEMPLATES ENDS HERE -->

    </ng-container>
  </div>
</div>